/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsUserPurchaseListItem,
    IdentityMelcoModelsUserPurchaseListItemFromJSON,
    IdentityMelcoModelsUserPurchaseListItemFromJSONTyped,
    IdentityMelcoModelsUserPurchaseListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsUserPurchaseListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem
     */
    list: Array<IdentityMelcoModelsUserPurchaseListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsUserPurchaseListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsUserPurchaseListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


